import { FC, useState } from 'react';
import EfSwiperLevel2 from '@elem/ui/ef-swiper-level2';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.EnergizeElectricity');
    const [listA, setListA] = useState([
        {
            desc: t('item1_title'),
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718790244088/11.jpg',
            h5List: [
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718799986988/a1.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718800000848/a2.jpg',
            ],
        },
        {
            desc: t('item2_title'),
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718790256766/22.jpg',
            h5List: [
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718800012722/b1.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718800025105/b2.jpg',
            ],
        },
        {
            desc: t('item3_title'),
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718886954516/a1.jpg',
            h5List: [
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718800038947/c1.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718800053046/c2.jpg',
            ],
        },
        {
            desc: t('item4_title'),
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718886984856/a2.jpg',
            h5List: [
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718800065911/d1.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718800077140/d2.jpg',
            ],
        },
    ]);
    return (
        <div className={`${css.thecomp} GtmModuleData-section`} data-section-id={'dp3-EnergizeElectricity'} data-section-title={t('title')}>
            <div className="comp-module">
                <div className="dp3-title">{t('title')}</div>
                {/* <Swiper
                    className={`swiper-box`}
                    modules={[Navigation, Pagination]}
                    navigation={true}
                    pagination={true}
                    spaceBetween={0}
                    slidesPerView={'auto'}
                    initialSlide={0}
                >
                    {listA.map((item, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <div key={index} className="comp-item">
                                    <div className="comp-item-content">
                                        <div className="comp-item-l">
                                            <EditorImg pc={item.pcL} />
                                        </div>
                                        <div className="comp-item-r">
                                            <EditorImg pc={item.pcR} />
                                        </div>
                                    </div>
                                    <div className="comp-item-title">{item.title}</div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper> */}
            </div>
            <EfSwiperLevel2 list={listA} hasLevel2={true} />
        </div>
    );
};

export default TheComp;
